import { MdEmail, MdLocalShipping, MdModeEdit } from "react-icons/md";
import { TbTruckReturn } from "react-icons/tb";
import {
    BsFillBagFill,
    BsFillSuitHeartFill,
    BsShieldShaded,
    BsFillCartFill,
    BsBell,
} from "react-icons/bs";
import { FaUserCircle, FaCheck } from "react-icons/fa";
import {
    IoIosArrowForward,
    IoIosArrowRoundBack,
    IoMdAddCircleOutline,
    IoMdRemoveCircleOutline,
    IoMdRemoveCircle,
} from "react-icons/io";
import { TfiMenu } from "react-icons/tfi";
import { RiArrowDropDownLine } from "react-icons/ri";
import { GrFormNextLink, GrFormPreviousLink } from "react-icons/gr";
import { RxDashboard, RxAvatar } from "react-icons/rx";
import {
    RiProductHuntLine,
    RiCoupon2Line,
    RiDeleteBin5Line,
} from "react-icons/ri";
import { HiOutlineClipboardDocumentCheck } from "react-icons/hi2";
import { IoMdRefresh } from "react-icons/io";
import { SiBrandfolder } from "react-icons/si";
import { CgProfile } from "react-icons/cg";
import { CiDiscount1 } from "react-icons/ci";

import {
    AiFillHome,
    AiFillStar,
    AiOutlineStar,
    AiFillEye,
    AiOutlineMenu,
    AiOutlineLoading,
    AiOutlineClose,
    AiFillGift,
    AiOutlineArrowRight,
    AiFillPhone,
    AiOutlineShoppingCart,
    AiOutlineSearch,
    AiOutlineArrowUp,
    AiOutlineEdit,
} from "react-icons/ai";

const icons = {
    AiFillPhone,
    MdEmail,
    BsFillBagFill,
    FaUserCircle,
    AiOutlineSearch,
    AiFillHome,
    AiFillStar,
    AiFillEye,
    BsFillSuitHeartFill,
    AiOutlineMenu,
    AiOutlineLoading,
    IoIosArrowForward,
    AiOutlineClose,
    TfiMenu,
    BsShieldShaded,
    MdLocalShipping,
    AiFillGift,
    TbTruckReturn,
    IoIosArrowRoundBack,
    AiOutlineArrowRight,
    RiArrowDropDownLine,
    GrFormNextLink,
    GrFormPreviousLink,
    BsFillCartFill,
    FaCheck,
    RxDashboard,
    RiProductHuntLine,
    AiOutlineShoppingCart,
    HiOutlineClipboardDocumentCheck,
    AiOutlineStar,
    RiCoupon2Line,
    BsBell,
    RxAvatar,
    MdModeEdit,
    RiDeleteBin5Line,
    IoMdRefresh,
    SiBrandfolder,
    IoMdAddCircleOutline,
    IoMdRemoveCircleOutline,
    AiOutlineArrowUp,
    IoMdRemoveCircle,
    CgProfile,
    AiOutlineEdit,
    CiDiscount1,
};

export default icons;
